import React from 'react'
import { Container, TextCaption, TextBody, State } from '@pmi/pmi-iqos-ds-react'

const DeviceInfoStatus = ({ status, bold, dataTestingSuffix, children }) => {
  const getState = () => {
    switch (status) {
      case 1:
        return State.states.valid
      case 2:
        return State.states.warning
      case 3:
        return State.states.warningGray
      default:
        return null
    }
  }

  return (
    <Container
      display={Container.displays.flex}
      flexDirection={Container.flexDirections.row}
      alignItems={Container.alignItemsValues.stretch}
      justifyContent={Container.justifyContentValues.start}>
      <Container width="6">
        <State state={getState()} size={[State.sizes.xs, State.sizes.s]} />
      </Container>
      <Container fullWidth pl={[null, '2']}>
        {children && typeof children === 'string' ? (
          bold ? (
            <TextCaption
              size={TextCaption.sizes.m}
              data-testing={
                dataTestingSuffix && 'Profile_TextCaption_' + dataTestingSuffix
              }>
              {children}
            </TextCaption>
          ) : (
            <TextBody>{children}</TextBody>
          )
        ) : (
          children
        )}
      </Container>
    </Container>
  )
}

export default DeviceInfoStatus
